import React, { Component } from "react";

class PersonalLoan extends Component {
  render() {
    return (
      <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <a href="/home" className="a-breadcrumbs">หน้าแรก</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการด้านสินเชื่อ</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="/personalloan" className="a-breadcrumbs">เงินกู้ฉุกเฉิน</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50" style={{width: '90%', fontFamily: '"Cordia New"'}}>
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>เงินกู้ฉุกเฉิน</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th style={{width: 150}}>สิทธิ</th>
                      <th style={{width: 150}}>เงินกู้เพื่อเหตุฉุกเฉิน</th>
                      <th>เงื่อนไข</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{width: 250}}>อายุงานไม่ถึง 1 ปี</td>
                      <td style={{width: 250}}>10,000 บาท</td>
                      <td rowSpan={5}>
                        <ul className="mb-25">
                          <li>เงินกู้เพื่อเหตุฉุกเฉินและเงินกู้เพื่อเหตุฉุกเฉินผ่านระบบของธนาคาร กู้ได้อย่างใดอย่างหนึ่ง จะกู้พร้อมกันทั้ง 2 ประเภทไม่ได้</li>
                          <li>ผ่อนได้สูงสุด 12 งวด</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>อายุงาน 1 ปีขึ้นไป แต่ไม่ถึง 2 ปี</td>
                      <td>20,000 บาท</td>
                    </tr>
                    <tr>
                      <td>อายุงาน 2 ปีขึ้นไป แต่ไม่ถึง 3 ปี</td>
                      <td>30,000 บาท</td>
                    </tr>
                    <tr>
                      <td>อายุงาน 3 ปีขึ้นไป แต่ไม่ถึง 4 ปี</td>
                      <td>40,000 บาท</td>
                    </tr>
                    <tr>
                      <td>อายุงาน 4 ปีขึ้นไป</td>
                      <td>50,000 บาท</td>
                    </tr>
                  </tbody>
                </table>
                <h3>ขั้นตอนการกู้เงินเพื่อเหตฉุกเฉิน</h3>
                <ul className="mb-25" style={{fontSize: 20}}>
                  <li>ยื่นคำขอกู้ผ่านทาง <u><a href="https://savingscoop.thaioilgroup.com/savingscoop/Home/" target="_blank" style={{color: '#4db6f1'}}>ระบบข้อมูลสมาชิกออนไลน์</a></u></li>
                  <li>รอรับสัญญากู้เงินเพื่อเหตุฉุกเฉินทาง E-mail</li>
                  <li>ส่งสัญญาที่ลงนามครบถ้วนมาที่สหกรณ์ </li>
                  <li>เมื่อสหกรณ์ได้รับสัญญา จึงจะจ่ายโอนเงินกู้ให้สมาชิกผ่านบัญชีธนาคารตามที่แจ้ง</li>
                  <li>รับเงินผ่านธนาคารไทยพาณิชย์และทหารไทยได้รับเงินเข้าบัญชีในวันเดียวกัน หลัง 17.00 น. รับเงินผ่านธนาคารอื่นๆได้รับเงินเข้าบัญชีภายใน 2 วันทำการถัดไป</li>
                </ul>
                <br/>
                <br/>
                <br/>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default PersonalLoan;
